import { Component } from '@angular/core';

@Component({
  selector: 'app-shared-error-dialog',
  templateUrl: './shared-error-dialog.component.html',
  styleUrls: ['./shared-error-dialog.component.scss']
})
export class SharedErrorDialogComponent {

}
